<template>
  <SfChip
    v-if="type === 'color'"
    :id="id"
    :data-testid="id"
    :size="size"
    square
    :class="selected ? '!border-primary-500 !ring-1 !ring-primary-500' : ''"
  >
    <SfTooltip :label="label ?? ''">
      <SfThumbnail class="!h-4 !w-4 !p-0" size="base" :aria-label="label" :style="`background-color: ${value}`" />
    </SfTooltip>
  </SfChip>
  <SfChip
    v-else-if="type === 'text'"
    :id="id"
    :data-testid="id"
    :size="size"
    square
    :class="selected ? '!border-primary-500 !bg-primary-500 !text-white' : ''"
  >
    <UiText :aria-label="label" class="px-3">{{ value }}</UiText>
  </SfChip>
</template>

<script setup lang="ts">
import type { ChipProps } from '~/components/ui/Chip/types';

withDefaults(defineProps<ChipProps>(), { selected: false });
</script>
